
class RecentlyViewed extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.renderRecentlyViewed();
  }

  renderRecentlyViewed() {
    const container = this.querySelector('.recently-viewed-products');
    if (!container) return;

    let recentlyViewed = [];
    try {
      recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
    } catch (e) {
      console.error('Recently Viewed: Error parsing localStorage', e);
      recentlyViewed = [];
    }

    const currentHandle = this.getAttribute('data-product-handle');
    const productsToShow = parseInt(this.getAttribute('data-products-to-show')) || 12;
    
    // Filter out current product from the list to display
    let displayList = recentlyViewed.filter(handle => handle !== currentHandle);

    // Limit the number of products to show
    displayList = displayList.slice(0, productsToShow);

    // In theme editor, if list is empty, show some mock data or just show the section
    if (Shopify.designMode && displayList.length === 0) {
      console.log('Recently Viewed: Design mode detected, showing placeholders');
      this.classList.remove('hidden');
      return;
    }

    if (displayList.length === 0) {
      this.classList.add('hidden');
      return;
    }

    const query = displayList.map(handle => `handle:${handle}`).join(' OR ');
    const searchUrl = window.routes ? window.routes.search_url : '/search';
    const sectionId = this.getAttribute('data-section-id') || 'angad-recently-viewed';
    const url = `${searchUrl}?section_id=${sectionId}&type=product&q=${encodeURIComponent(query)}&options[prefix]=last&limit=20`;

    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(text => {
        console.log('Recently Viewed: Fetch successful');
        const html = new DOMParser().parseFromString(text, 'text/html');
        const results = html.querySelectorAll('.recently-viewed-products .grid__item');
        
        if (results && results.length > 0) {
          // Reorder results based on displayList
          const resultsMap = new Map();
          results.forEach(item => {
            const handle = item.getAttribute('data-handle');
            if (handle) resultsMap.set(handle, item);
          });

          container.innerHTML = '';
          displayList.forEach(handle => {
            const item = resultsMap.get(handle);
            if (item) container.appendChild(item);
          });

          this.classList.remove('hidden');
        } else {
          console.log('Recently Viewed: No results found in response');
          if (!Shopify.designMode) this.classList.add('hidden');
        }
      })
      .catch(e => {
        console.error('Recently Viewed Error:', e);
        if (!Shopify.designMode) this.classList.add('hidden');
      });
  }
}

if (!customElements.get('recently-viewed')) {
  customElements.define('recently-viewed', RecentlyViewed);
}
